/* MIIM.MIIC — PIICKED landing page behaviour */
(function () {
  var PRICE = 39;
  var DISCOUNT = 0.25;

  /* ---------- add-to-cart (single item, used by scent-section buttons) ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      var variantId = add.dataset.variantId;
      if (!variantId) return;

      addToCart([{ id: parseInt(variantId, 10), quantity: 1 }]);

      if (!add.classList.contains('mm-bundle-cta')) {
        var base = add.dataset.base || add.textContent;
        add.dataset.base = base;
        add.classList.add('added');
        add.textContent = 'ADDED \u2713';
        clearTimeout(add._t);
        add._t = setTimeout(function () {
          add.classList.remove('added');
          add.textContent = base;
        }, 2500);
      }
      return;
    }

    var faq = e.target.closest('[data-faq]');
    if (faq) faq.classList.toggle('open');
  });

  /* ---------- bundle builder ---------- */
  var builder = document.querySelector('[data-builder]');
  if (builder) {
    var tiles = [].slice.call(builder.querySelectorAll('[data-tile]'));
    var slots = [].slice.call(builder.querySelectorAll('[data-slot]'));
    var count = builder.querySelector('[data-count]');
    var bar = builder.querySelector('[data-progress]');
    var gross = builder.querySelector('[data-gross]');
    var saveVal = builder.querySelector('[data-save]');
    var total = builder.querySelector('[data-total]');
    var cta = builder.querySelector('.mm-bundle-cta');
    var note = builder.querySelector('[data-note]');
    var picked = [];

    function money(n) { return '$' + n.toFixed(2); }

    function render() {
      var full = picked.length === 3;
      builder.classList.toggle('complete', full);
      tiles.forEach(function (t) {
        if (t.dataset.available === 'false') return; // leave the SOLD OUT pill alone
        var on = picked.indexOf(t.dataset.tile) !== -1;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.style.outline = on ? '2px solid ' + t.dataset.accent : 'none';
        var pill = t.querySelector('.pill');
        pill.textContent = on ? 'PIICKED \u2713' : 'ADD TO BUNDLE';
        pill.style.background = on ? t.dataset.accent : '#fff';
        pill.style.color = on ? (t.dataset.light === 'true' ? '#000' : '#fff') : '#000';
        pill.style.borderColor = on ? t.dataset.accent : '#000';
      });
      slots.forEach(function (s, i) {
        var id = picked[i];
        var tile = id ? tiles.filter(function (t) { return t.dataset.tile === id; })[0] : null;
        s.classList.toggle('filled', !!tile);
        s.querySelector('.accent').style.background = tile ? tile.dataset.accent : '';
        s.querySelector('.label').textContent = tile ? tile.dataset.name : 'EMPTY SLOT';
        s.querySelector('.amt').textContent = tile ? money(PRICE) : '';
      });
      var g = picked.length * PRICE;
      var save = full ? g * DISCOUNT : 0;
      count.textContent = picked.length + ' OF 3';
      bar.style.width = Math.round((Math.min(picked.length, 3) / 3) * 100) + '%';
      gross.textContent = money(g);
      saveVal.textContent = full ? '\u2212' + money(save) : '\u2014';
      total.textContent = money(g - save);
      if (!cta.classList.contains('added') && !cta.classList.contains('loading')) {
        cta.textContent = full ? 'ADD BUNDLE TO CART \u2014 ' + money(g - save) : 'PIICK ' + (3 - picked.length) + ' MORE';
      }
      note.textContent = full
        ? 'Bundle complete. 25% off is locked in.'
        : picked.length === 0
          ? 'Piick three formulas to unlock the discount.'
          : 'Add ' + (3 - picked.length) + ' more to unlock 25% off.';
    }

    tiles.forEach(function (t) {
      if (t.dataset.available === 'false') {
        t.disabled = true;
        t.classList.add('sold-out');
        t.style.opacity = '0.45';
        t.style.cursor = 'not-allowed';
        var soldPill = t.querySelector('.pill');
        if (soldPill) soldPill.textContent = 'SOLD OUT';
        return; // never made pickable, so it can never end up in `picked`
      }
      t.addEventListener('click', function () {
        var id = t.dataset.tile;
        var at = picked.indexOf(id);
        if (at !== -1) picked.splice(at, 1);
        else if (picked.length < 3) picked.push(id);
        render();
      });
    });

    /* bundle "ADD BUNDLE TO CART" — actually adds the 3 picked variants and opens the drawer */
    cta.addEventListener('click', function () {
      if (picked.length !== 3 || cta.classList.contains('loading') || cta.classList.contains('added')) return;

      var items = picked
        .map(function (id) {
          var tile = tiles.filter(function (t) { return t.dataset.tile === id; })[0];
          return tile ? tile.dataset.variantId : null;
        })
        .filter(Boolean)
        .map(function (variantId) {
          return { id: parseInt(variantId, 10), quantity: 1 };
        });

      if (items.length !== 3) {
        note.textContent = 'One of the picked formulas is missing a variant — please re-select.';
        return;
      }

      var savedText = cta.textContent;
      cta.classList.add('loading');
      cta.disabled = true;
      cta.textContent = 'ADDING\u2026';

      addToCart(items)
        .then(function () {
          cta.classList.remove('loading');
          cta.disabled = false;
          cta.classList.add('added');
          cta.textContent = 'ADDED \u2713';
          setTimeout(function () {
            cta.classList.remove('added');
            render();
          }, 1800);
        })
        .catch(function (err) {
          cta.classList.remove('loading');
          cta.disabled = false;
          cta.textContent = savedText;
          note.textContent = (err && err.description) || 'Could not add the bundle to cart. Please try again.';
          console.error('[MIIM.MIIC] Bundle add-to-cart failed:', err);
        });
    });

    render();
  }

  /* ---------- hero video ---------- */
  var v = document.querySelector('[data-hero-video]');
  if (v) { v.muted = true; v.loop = true; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* ---------- scroll reveals ---------- */
  var reveals = document.querySelectorAll('.reveal,.reveal-grid');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.05 });
    [].forEach.call(reveals, function (n) { io.observe(n); });
  } else {
    [].forEach.call(reveals, function (n) { n.classList.add('in'); });
  }

  /* ---------- shared add-to-cart core ---------- */
  /* items: array of { id, quantity } — works for a single product OR the 3-item bundle */
  function addToCart(items) {
    var dsid = getDrawerSectionId();
    var body = { items: items };
    if (dsid) {
      body.sections = dsid;
      body.sections_url = window.location.pathname || '/';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok)
          return r.json().then(function (e) {
            throw e;
          });
        return r.json();
      })
      .then(function (data) {
        if (dsid && data.sections && data.sections[dsid]) replaceDrawer(data.sections[dsid]);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var cnt = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            updateCartCount(cnt);
            ['theme:cart:reload', 'theme:cart:change', 'cart:refresh', 'cart:change', 'cart:updated'].forEach(
              function (e) {
                try {
                  document.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: cart }));
                } catch (_) {}
              }
            );
            setTimeout(function () {
              updateCartCount(cnt);
            }, 150);
            setTimeout(function () {
              updateCartCount(cnt);
            }, 500);
            setTimeout(openDrawer, 120);
            return data;
          });
      });
  }

  function getDrawerSectionId() {
    var w = document.querySelector('[data-section-type="cart-drawer"]');
    if (w && w.dataset.sectionId) return w.dataset.sectionId;
    var d = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (d) {
      var pEl = d.closest('[data-section-id]');
      if (pEl) return pEl.dataset.sectionId;
    }
    return null;
  }

  function updateCartCount(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) n = 0;
    document.querySelectorAll('cart-count').forEach(function (elx) {
      elx.setAttribute('data-cart-count', n);
      var lim = parseInt(elx.dataset.limit, 10);
      elx.textContent = !isNaN(lim) && lim > 0 && n > lim ? lim + '+' : String(n);
    });
    [
      '[data-cart-count]:not(cart-count)',
      '.cart-count',
      '.cart__count',
      '.cart-item-count',
      '.header__cart-count',
      '.cart-link__bubble-num',
      '[data-item-count]',
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (elx) {
        elx.textContent = String(n);
        if (elx.hasAttribute('data-cart-count')) elx.setAttribute('data-cart-count', n);
        if (elx.hasAttribute('data-item-count')) elx.setAttribute('data-item-count', n);
      });
    });
  }

  function replaceDrawer(html) {
    if (!html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nd = doc.querySelector('cart-drawer');
      var od = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
      if (nd && od) {
        var open = [];
        ['is-active', 'active', 'open', 'is-open', 'drawer--open'].forEach(function (c) {
          if (od.classList.contains(c)) open.push(c);
        });
        var imp = document.importNode(nd, true);
        od.parentNode.replaceChild(imp, od);
        open.forEach(function (c) {
          imp.classList.add(c);
        });
        imp.querySelectorAll('script').forEach(function (os) {
          var ns = document.createElement('script');
          Array.prototype.forEach.call(os.attributes, function (a) {
            ns.setAttribute(a.name, a.value);
          });
          ns.textContent = os.textContent;
          os.parentNode.replaceChild(ns, os);
        });
      }
    } catch (e) {
      console.error('[MIIM.MIIC] Drawer swap:', e);
    }
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') {
      try {
        d.open();
        return;
      } catch (e) {}
    }
    var t =
      document.querySelector('[data-action="open-drawer"][data-drawer-id="cart-drawer"]') ||
      document.querySelector('[aria-controls="cart-drawer"]:not([data-cart-drawer-close])') ||
      document.querySelector('.navlink--cart') ||
      document.querySelector('[data-cart-toggle]');
    if (t) {
      try {
        t.click();
        return;
      } catch (e) {}
    }
    ['theme:drawer:open', 'drawer:open', 'cart-drawer:open'].forEach(function (e) {
      try {
        document.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: { drawer: 'cart-drawer' } }));
      } catch (_) {}
    });
    if (d) {
      d.classList.add('is-active', 'active', 'open', 'is-open', 'drawer--open');
      d.removeAttribute('hidden');
    }
  }
})();